import { AuthenticationFacade } from '../authentication/auth/facade/auth-facade.service';
import { Injectable, inject, signal } from '@angular/core';
import { SavePinBase } from '../providers/save-pin-base/save-pin-base';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class PinInSessionService extends SavePinBase {
  private readonly auth: AuthenticationFacade = inject(AuthenticationFacade);
  private credentials = signal<{ username: string; pin: string }>({ username: '', pin: '' });

  constructor() {
    super();
    this.auth.authenticationChange$
      .pipe(
        takeUntilDestroyed(),
        filter((authenticated) => !authenticated),
      )
      .subscribe(() => {
        this.credentials.set({ username: '', pin: '' });
      });
  }

  public async setPin(username: string, pin: string): Promise<void> {
    if (pin === '' || pin === null) {
      throw new Error('pin cannot be empty');
    }
    if (username) {
      const value = { username: username, pin: pin };
      this.credentials.set(value);
    }
  }
  public async getPin(): Promise<string | null> {
    return this.credentials().pin;
  }

  public async resetPin(): Promise<void> {
    if (this.credentials().username) {
      this.credentials.set({ username: '', pin: '' });
    }
  }
}
